export const actionsBar = {
  display: "flex",
  flexDirection: "row",
};

export const imagesButton = ({ backgroundUrl }) => ({
  backgroundColor: "white",
  backgroundImage: `url(${backgroundUrl})`,
  backgroundSize: "contain",
  backgroundPosition: "50% 50%",
  backgroundRepeat: "no-repeat",
  border: "solid 1px",
  borderColor: "black",
  borderRadius: 0,
  cursor: "pointer",
  width: "60px",
  height: "60px",
  margin: "0 2px 0 0",
  flexGrow: 0,
  flexShrink: 0,
});

export const menuButton = {
  backgroundColor: "black",
  border: "none",
  borderRadius: 0,
  cursor: "pointer",
  width: "60px",
  height: "60px",
  margin: "0 0 0 2px",
  flexGrow: 0,
  flexShrink: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const addToOrderButton = {
  borderRadius: 0,
  flexGrow: 1,
  flexShrink: 1,
};

export const changeImageDrawer = {
  background: "background",
  borderRadius: "20px 20px 0px 0px",
  p: "20px 0",
  border: "solid 1px",
  borderBottomWidth: "0",
  borderColor: "text",
  position: "absolute",
  bottom: 0,
  left: "25px",
  right: "25px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  zIndex: 2000,
};

export const horizontalScrollContainer = {
  position: "relative",
  overflow: "hidden",
  maxWidth: "100%",

  "&:before, &:after": {
    content: '""',
    position: "absolute",
    top: 0,
    bottom: 0,
    width: "20px",
    pointerEvents: "none",
  },

  "&:before": {
    backgroundImage:
      "linear-gradient(90deg, rgba(255, 255, 255, 1) 30%, rgba(255, 255, 255, 0))",
    left: 0,
  },

  "&:after": {
    backgroundImage:
      "linear-gradient(-90deg, rgba(255, 255, 255, 1) 30%, rgba(255, 255, 255, 0))",
    right: 0,
  },
};

export const hideScroll = {
  height: "60px",
  overflow: "hidden",
  width: "100%",
};

export const horizontalScroll = {
  overflow: "auto",
  overflowX: "auto",
  overflowY: "hidden",
  maxWidth: "100%",
  px: "20px",
  pb: "200px", // to hide the scrollbar from view
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
};

export const imagesContainer = {
  display: "flex",
  flexDirection: "row",
  flexWrap: "nowrap",
  float: "left",
  gap: "10px",
};

export const image = ({ backgroundImageUrl, isSelected }) => {
  return {
    cursor: "pointer",
    width: "60px",
    height: "60px",
    flexGrow: 0,
    flexShrink: 0,
    backgroundColor: "background",
    border: "1px solid transparent",
    borderWidth: isSelected ? "2px" : "1px",
    borderColor: isSelected ? "primary" : "text",
    borderRadius: "1000px",
    backgroundImage: `url("${backgroundImageUrl}")`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center",
    backgroundSize: "contain",
  };
};
